import { styled } from '@mui/material';
import { useViewport } from 'contexts/viewport';
import { forwardRef } from 'react';
import Box from 'shell/components/Box';
import Button from 'shell/components/Button';
import Skeleton from 'shell/components/Skeleton';
import Stack from 'shell/components/Stack';
import Text from 'shell/components/Text';
import Card from './Card';

const StudentAssignmentCard = forwardRef(
    ({ assignment, numAttemptsRemaining, onClick, onClickGetFeedback, onClickViewFeedback, ...rest }, ref) => {
        const { device } = useViewport();

        const handleClick = (e) => {
            e.stopPropagation();
            if (!numAttemptsRemaining) {
                onClickViewFeedback(assignment);
            } else {
                onClickGetFeedback(assignment);
            }
        };

        return (
            <RootBox ref={ref} {...rest}>
                <Card onClick={() => onClick(assignment)}>
                    <RootStack
                        alignItems={'center'}
                        direction={device === 'mobile' ? 'column' : 'row'}
                        justifyContent={'space-between'}
                        spacing={2}
                    >
                        <CustomStack alignItems={'flex-start'} device={device} spacing={2}>
                            {isNaN(numAttemptsRemaining) ? (
                                <Skeleton width={100} />
                            ) : (
                                <Text color={'light'} variant={'p3'}>
                                    {numAttemptsRemaining} attempts remaining
                                </Text>
                            )}

                            <Text align={'left'} noWrap variant={'sh2'}>
                                {assignment.title}
                            </Text>
                        </CustomStack>
                        <CustomButton device={device} loading={isNaN(numAttemptsRemaining)} onClick={handleClick}>
                            {!numAttemptsRemaining ? 'View' : 'Get'} Feedback
                        </CustomButton>
                    </RootStack>
                </Card>
            </RootBox>
        );
    }
);

const RootBox = styled(Box)(() => {
    return {
        width: '100%',
    };
});

const RootStack = styled(Stack)(({ theme }) => {
    return {
        width: '100%',
        padding: theme.spacing(2),
    };
});

const CustomStack = styled(Stack)(({ device }) => {
    return {
        ...(device === 'mobile'
            ? {
                  width: '100%',
              }
            : {
                  minWidth: 0,
                  maxWidth: '75ch',
              }),
    };
});

const CustomButton = styled(Button)(({ device }) => {
    return {
        flexShrink: 0,
        width: device === 'mobile' ? '100%' : '130px',
    };
});

export default StudentAssignmentCard;
